import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: () => import('@/views/homePage/homePage'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/product/product'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/productDetail/:pid',
    name: 'productDetail',
    component: () => import('@/views/product/productDetail'),
    props: true
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('@/views/brand/brand'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/brandDetail/:brandName',
    name: 'brandDetail',
    component: () => import('@/views/brand/brandDetail'),
    props: true,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/aboutUs/aboutUs')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/news'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/newsDetail/:nid',
    name: 'newsDetail',
    component: () => import('@/views/news/newsDetail'),
    props: true
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('@/views/contactUs/contactUs')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/views/policy')
  },
  {
    path: '/cookie',
    name: 'cookie',
    component: () => import('@/views/cookie')
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/404')
  },
];


const router = new Router({
  mode: 'history', // hash or history
  routes
});

export default router;